var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#7075E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0201 14.1558C34.3713 14.8046 33.2581 15.0019 32.6094 14.3532L29.7909 11.5347C29.078 10.8218 27.922 10.8218 27.2091 11.5347L24.3906 14.3532C23.7419 15.0019 22.6287 14.8046 21.9799 14.1558C19.8194 11.9953 16.3164 11.9953 14.1558 14.1558C11.9953 16.3164 11.9953 19.8194 14.1558 21.9799C14.8046 22.6287 15.0019 23.7419 14.3532 24.3906L11.5347 27.2091C10.8218 27.922 10.8218 29.078 11.5347 29.7909L14.3532 32.6094C15.0019 33.2581 16.1151 33.0608 16.7639 32.412C18.9244 30.2515 22.4274 30.2515 24.588 32.412C26.7485 34.5726 26.7485 38.0756 24.588 40.2361C23.9392 40.8849 23.7419 41.9981 24.3906 42.6468L27.2091 45.4653C27.922 46.1782 29.078 46.1782 29.7909 45.4653L32.6094 42.6468C33.2581 41.998 34.3713 42.1954 35.0201 42.8442C37.1806 45.0047 40.6836 45.0047 42.8442 42.8442C45.0047 40.6836 45.0047 37.1806 42.8442 35.0201C42.1954 34.3713 41.9981 33.2581 42.6468 32.6094L45.4653 29.7909C46.1782 29.078 46.1782 27.922 45.4653 27.2091L42.6468 24.3906C41.9981 23.7419 42.1954 22.6287 42.8442 21.9799C45.0047 19.8194 45.0047 16.3164 42.8442 14.1558C40.6836 11.9953 37.1806 11.9953 35.0201 14.1558Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/PUZZLE.e070c83efd998a9a27c29489877a881f.svg";
export { ForwardRef as ReactComponent };